import formatPrice from 'ha/utils/formatPrice';

export const priceRange = (
  currency: string,
  minPrice?: number,
  maxPrice?: number,
): string =>
  [minPrice, maxPrice]
    .filter(price => price !== undefined)
    .map(price => formatPrice(price as number, currency))
    .join(' - ');
